import { TOnClick, TSide } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import React from "react"
import { TIconKey } from "../Icons/Icon/Interfaces"
import PreferencesMediumButton from "./PreferencesMediumButton"

interface Props {
	iconKey?: TIconKey
	iconSide?: TSide
	children?: React.ReactNode
	onClick?: TOnClick<HTMLButtonElement>
	style?: React.CSSProperties
}

const PreferencesSmallButton = ({ iconKey, iconSide, children, onClick, style }: Props) => {
	return (
		<PreferencesMediumButton
			style={{
				height: 38,
				fontSize: 16,
				...style,
			}}
			iconKey={iconKey}
			iconWidth={16}
			iconHeight={16}
			iconSide={iconSide}
			children={children}
			onClick={onClick}
		/>
	)
}

export default PreferencesSmallButton
